import {usePathname} from 'next/navigation';

// ToDo: подумать, как можно избавиться от использования флага
export const useIsGamesPage = (): boolean => {
  const path = usePathname();

  return path?.includes('/games') || false;
};
